module.exports = __webpack_public_path__ + "img/erro_triangle.f9251b6f.svg";